import Vue from 'vue/dist/vue.js';

const inputSlider = Vue.component('input-slider',
    {
        delimiters: ['@{','}'],

        template: `<div class="input-slider">
                        <label for="attr" class="d-none">@{ label }</label>
                        <input type="range"
                            v-model="range"
                            :id="attr"
                            :min="min"
                            :max="max"
                            :disabled="isDisabled"
                            class="form-slider"
                            :step="step"
                            @input="sliderChanged" />
                    </div>`,

        props : [ 'start', 'min', 'max', 'step', 'label', 'attr', 'callback', 'disabled' ],

        computed :
        {
            isDisabled()
            {
                return (this.disabled=="1") ? true : false;
            }
        },

        data: function()
        {
            return {
                range : null,
            }
        },

        created ()
        {
            this.range = this.start;

            setTimeout(this.setSlider, 1000);
        },

        watch:
        {
            max()
            {
                this.setSlider();
            },
        },

        methods:
        {
            sliderChanged()
            {
                this.setSlider();
                this.$emit(this.callback, this.range);
            },

            setSlider()
            {
                const el = document.getElementById(this.attr);

                const min = this.min;
                const max = this.max;
                const val = this.range;

                el.style.backgroundSize = (val - min) * 100 / (max - min) + '% 100%';
            }
        },

});

export default inputSlider;